<template>
  <ins
    :style="insStyle"
    :data-ad-client="dataAdClient"
    :data-ad-slot="dataAdSlot"
    :data-ad-format="dataAdFormat"
    data-full-width-responsive="false"
    class="adsbygoogle"
  ></ins>
</template>

<script>
export default {
  props: {
    insStyle: {
      type: String,
      default: 'display:block'
    },
    dataAdClient: {
      type: String,
      default: 'ca-pub-3462459249538400'
    },
    dataAdSlot: {
      type: String,
      default: ''
    },
    dataAdFormat: {
      type: String,
      default: 'auto'
    },
    dataFullWidthResponsive: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },

  mounted() {
    if (this.width) {
      window.$(this.$el).width(this.width)
    }
    if (this.height) {
      window.$(this.$el).height(this.height)
    }
    setTimeout(() => {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
    }, 500) // 枠サイズが固定されてからレンダリングを開始する必要があるため少し時間おく
  }
}
</script>

<style lang="sass" scoped>
ins
  // background-color: gray
</style>



// WEBPACK FOOTER //
// src/components/Adsense.vue